import { render, staticRenderFns } from "./DataUploadFileCard.vue?vue&type=template&id=2282d34a&"
import script from "./DataUploadFileCard.vue?vue&type=script&lang=js&"
export * from "./DataUploadFileCard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports